<template>
  <v-main class="pa-3">
        <v-card flat >

        <v-row justify-center >
          <v-col xs="12" sm="8" lg="6">
            <v-card class="ml-2 mr-1 rounded-t-xl">
              <div id>
                <v-skeleton-loader type="image" v-show="seriesAtendimentoStatus.length == 0"/>
                <!-- {{seriesAtendimentoStatus}} -->
                <apexchart class="mt-3" v-if="seriesAtendimentoStatus.length > 0" type="donut" :options="chartOptionsAtendimentoStatus" :series="seriesAtendimentoStatus" height="250" />
              </div>
            </v-card>
            <v-card dark color="primary" class="ml-2 mr-1 rounded-b-xl">
              <v-card-text class="text-center white--text primary">
                <div class="headline">
                  Status das senhas geradas
                </div>
                <v-btn outlined block class="subtitle-1 mt-1" rounded dark :loading="loadingChartStatus" :disabled="loadingChartStatus"  @click="retornarQuantAtendimentoStatus">
                  {{ textButtonAtualizarChartStatus }}
                </v-btn>
              </v-card-text>

            </v-card>
          </v-col>

          <v-col xs="12" sm="8" lg="6">
            <v-card class="rounded-t-xl pa-2 ml-1 mr-2 mt-3">
              <div id="chartSenhasGeradas24Horas" class="v-sheet--offset pa-0 ma-0" />
            </v-card>
            <v-card dark color="primary" class="rounded-b-xl ml-1 mr-2">
              <!-- <div id="chartSenhasGeradas24Horas" class="v-sheet--offset pa-0 ma-0" /> -->
              <v-card-text>
                <v-layout row>
                  <strong class=" ml-3 title white--text" >Senhas geradas por hora</strong>
                <v-spacer />
                <v-btn to="/graficos" outlined class="mr-4 mb-3" dark>
                  ver mais..
                  <v-icon dark>
                    graphic_eq
                  </v-icon>
                </v-btn>
                </v-layout>

                <v-divider class="" />
                <v-icon class="mr-2" dark small>
                  av_timer
                </v-icon>
                <span class="caption white--text font-weight-light pt-0">Último registro à {{ textTempoAtualizado }} atrás</span>
              </v-card-text>

            </v-card>
          </v-col>

          <v-col xs="12" sm="8" lg="6">
            <v-card class="ml-2 mr-1 rounded-t-xl">
              <div id>
                <v-skeleton-loader type="image" v-show="seriesAtendimentoStatus.length == 0"/>
                <!-- {{seriesAtendimentoStatus}} -->
                <apexchart class="mt-3" v-if="seriesAtendimentoStatus.length > 0" type="donut" :options="chartOptionsAtendimentoStatus" :series="seriesAtendimentoStatus" height="250" />
              </div>
            </v-card>
            <v-card dark color="primary" class="ml-2 mr-1 rounded-b-xl">
              <v-card-text class="text-center white--text primary">
                <div class="headline">
                  Especialidades médicas
                </div>
                <v-btn outlined block class="subtitle-1 mt-1" rounded dark :loading="loadingChartStatus" :disabled="loadingChartStatus"  @click="retornarQuantAtendimentoStatus">
                  {{ textButtonAtualizarChartStatus }}
                </v-btn>
              </v-card-text>

            </v-card>
          </v-col>

          <v-col xs="12" sm="8" lg="6">
            <v-card class="rounded-t-xl pa-2 ml-1 mr-2 mt-3">
              <div id="chartSenhasGeradas24Horas" class="v-sheet--offset pa-0 ma-0" />
            </v-card>
            <v-card dark color="primary" class="rounded-b-xl ml-1 mr-2">
              <!-- <div id="chartSenhasGeradas24Horas" class="v-sheet--offset pa-0 ma-0" /> -->
              <v-card-text>
                <v-layout row>
                  <strong class=" ml-3 title white--text" >Atendimentos médicos por hora</strong>
                <v-spacer />
                <v-btn to="/graficos" outlined class="mr-4 mb-3" dark>
                  ver mais..
                  <v-icon dark>
                    graphic_eq
                  </v-icon>
                </v-btn>
                </v-layout>

                <v-divider class="" />
                <v-icon class="mr-2" dark small>
                  av_timer
                </v-icon>
                <span class="caption white--text font-weight-light pt-0">Último registro à {{ textTempoAtualizado }} atrás</span>
              </v-card-text>

            </v-card>
          </v-col>
          <!-- <v-flex md12 class="pa-5">
            <v-row no-gutters style="height: 150px;">
              <v-col cols="3">
                <v-card class="mr-1" dark :to="{path:'listaMedicosUnidade'}" hover color="primary darken-2 rounded-xl">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title class="title">
                        Médicos da Unidade
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-avatar tile size="80">
                      <v-img contain height="80px" :src="require('../../assets/iconsAdmUnidade/medico.png')" />
                    </v-list-item-avatar>
                  </v-list-item>
                  <v-divider light />
                  <v-card-actions class="pa-3">
                    {{ qtdMedicos }} Médico(s) cadastrados
                    <br>
                    {{ qtdMedicosOnline }} Médico(s) Online
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="3">
                <v-card dark :to="{path:'metricas'}" hover color="primary darken-2 rounded-xl" class="mr-1">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title class="title">
                        Métricas da Unidade
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-avatar tile size="80">
                      <v-img contain :src="require('../../assets/iconsAdmUnidade/metricas.png')" />
                    </v-list-item-avatar>
                  </v-list-item>

                  <v-divider light />
                  <v-card-actions class="pa-3">
                    Verificar dados correspondentes ao atendimento nesta unidade
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="3">
                <v-card dark class="mr-1" :to="{path:'listaTecnicosUnidade'}" hover color="primary darken-2 rounded-xl">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title class="title">
                        Técnicos da Unidade
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-avatar tile size="80">
                      <v-img contain weight="190px" height="100px" :src="require('../../assets/iconsAdmUnidade/tecnico.png')" />
                    </v-list-item-avatar>
                  </v-list-item>
                  <v-divider light />
                  <v-card-actions class="pa-3">
                    {{ qtdTecnico }} Técnicos(s) cadastrados
                    <br>
                    {{ qtdTecnicosOnline }} Técnicos(s) Online
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="3">
                <v-card dark :to="{path:'funcionariosOnline'}" hover color="primary darken-2 rounded-xl">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title class="title">
                        Funcionários Online
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-avatar tile size="80">
                      <v-img :src="require('../../assets/iconsAdmUnidade/online.png')" />
                    </v-list-item-avatar>
                  </v-list-item>
                  <v-divider light />
                  <v-card-actions class="pa-3">
                    Verificar funcionários conectados
                    {{qtdMedicos}} médico(s) cadastrados
                    <br>
                    {{ this.total }} Funcionário(s) Online
                    <v-spacer />
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="3">
                <v-card dark :to="{path:'listaRecepcionistasUnidade'}" color="primary darken-2 rounded-xl" class="mr-1 mt-2">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title class="title">
                        Recepcionistas da Unidade
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-avatar tile size="80">
                      <v-img :src="require('../../assets/iconsAdmUnidade/recepcionista.png')" />
                    </v-list-item-avatar>
                  </v-list-item>
                  <v-divider light />
                  <v-card-actions class="pa-2">
                    {{ qtdRecepcionista }} Recepcionista(s) cadastrados
                    <br>
                    {{ qtdRecepcionistasOnline }} Recepcionista(s) Online
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="3">
                <v-card dark :to="{path:'listaAtendentesUnidade'}" hover color="primary darken-2 rounded-xl" class="mr-1 mt-2">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title class="title">
                        Atendentes da unidade
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-avatar tile size="80">
                      <v-img :src="require('../../assets/iconsAdmUnidade/atendente.png')" />
                    </v-list-item-avatar>
                  </v-list-item>
                  <v-divider light />
                  <v-card-actions class="pa-2">
                    {{ qtdAtendente }} Atendente(s) cadastradas
                    <br>
                    {{ qtdAtendentesOnline }} Atendente(s) online
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="3">
                <v-card dark :to="{path:'listaPaineisUnidade'}" hover color="primary darken-2 rounded-xl" class="mr-1 mt-2">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title class="title">
                        Painéis da unidade

                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-avatar tile size="80">
                      <v-img contain :src="require('../../assets/iconsAdmUnidade/painel.png')" />

                    </v-list-item-avatar>
                  </v-list-item>

                  <v-divider light />
                  <v-card-actions class="pa-2">
                    {{ qtdVisor }} Painel(éis) cadastrado(s)
                    <br>
                    {{ qtdVisoresOnline }} Painel(éis) online
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="3">
                <v-card dark :to="{path:'listaApoioUnidade'}" hover color="primary darken-2 rounded-xl" class="mt-2">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title class="title">
                        Funcionários do apoio
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-avatar tile size="80">
                      <v-img :src="require('../../assets/iconsAdmUnidade/apoio.png')" />

                    </v-list-item-avatar>
                  </v-list-item>

                  <v-divider light />
                  <v-card-actions class="pa-2">
                    {{ qtdApoio }} Funcionário(s) de apoio cadastrado(s)
                    <br>
                    {{ qtdApoiosOnline }} Funcionário(s) de apoio online
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="3">
                <v-card dark :to="{path:'servicosUnidade'}" color="primary darken-2 rounded-xl" class="mr-1 mt-2 mb-2">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title class="title">
                        Serviços prestados
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-avatar tile size="80">
                      <v-img contain :src="require('../../assets/iconsAdmUnidade/servicos.png')" />

                    </v-list-item-avatar>
                  </v-list-item>
                  <v-divider light />
                  <v-card-actions class="pa-2">
                    {{ qtdServicos }} Serviço(s) prestado(s) pela unidade
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="3">
                <v-card dark :to="{path:'pacienteInfoOs'}" color="primary darken-2 rounded-xl" class="mr-1 mt-2 mb-2">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title class="title">
                        Informações do paciente
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-avatar tile size="80">
                      <v-img contain :src="require('../../assets/iconsAdmUnidade/paciente.png')" />
                    </v-list-item-avatar>
                  </v-list-item>
                  <v-divider light />
                  <v-card-actions class="pa-2">
                    Lista de exames lançados por (OS)
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="3">
                <v-card dark :to="{path:'infoSenhas'}" hover color="primary darken-2 rounded-xl" class="my-2">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title class="title">
                        Listar senhas
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-avatar tile size="80">
                      <v-img contain :src="require('../../assets/iconsAdmUnidade/paste.png')" />
                    </v-list-item-avatar>
                  </v-list-item>
                  <v-divider light />
                  <v-card-actions class="pa-2">
                    Senhas lançadas durante o dia
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="3">
                <v-card dark :to="{path:'anuncios'}" hover color="primary darken-2 rounded-xl" class="my-2 ml-1">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title class="title">
                        Anúncios
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-avatar tile size="80">
                      <v-img contain :src="require('../../assets/iconsAdmUnidade/subscriptions.png')" />
                    </v-list-item-avatar>
                  </v-list-item>
                  <v-divider light />
                  <v-card-actions class="pa-2">
                    Gerenciar anúncios
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-flex> -->
        </v-row>
      </v-card>
  </v-main>
  </template>

<script>
// import Cookies from 'js-cookie'
import ApexCharts from 'apexcharts'
import VueApexCharts from 'vue-apexcharts'
import administradorUnidadeService from '../../services/administradorUnidade.service'
import socketService from '../../services/socket.service'
import {
  getToken
} from '../../store/auth'

export default {
  name: 'CadastrarLocalUnidade',
  components: {
    apexchart: VueApexCharts
  },
  data () {
    return {
      textTempoAtualizado: '',
      intervalRegistroSocket: '',
      optionschartSenhasGeradas24Horas: {
        chart: {
          type: 'line',
          height: 235
        },
        noData: {
          text: 'Carregando...'
        },
        series: [],
        markers: {
          size: 1
        },
        dataLabels: {
          enabled: true,
          enabledOnSeries: [2]
        },
        yaxis: [{
          title: {
            text: 'Senhas geradas'
          }
        }],
        xaxis: {
          categories: [
            '6h',
            '7h',
            '8h',
            '9h',
            '10h',
            '11h',
            '12h',
            '13h',
            '14h',
            '15h',
            '16h',
            '17h'
          ]
        }
      },

      seriesAtendimentoStatus: [],
      chartOptionsAtendimentoStatus: {
        chart: {
          type: 'donut',
          id: 'vuechart-senhasGeradas',
          height: 300
        },
        noData: {
          text: 'Carregando...'
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                total: {
                  showAlways: true,
                  show: true,
                  fontSize: 20
                },
                value: {
                  show: true,
                  fontSize: '22px'
                }
              }

            }

          }
        },
        labels: [
          'Pendente',
          'Chamado (Recepcionista)',
          'Em atendimento',
          'Atendimento transferido',
          'Em espera',
          'Cancelado',
          'Não Atendido',
          'Atendido',
          'Chamando paciente (Médico)',
          'Em atendimento (Médico)',
          'Consultado'
        ],
        responsive: [{
          breakpoint: 280,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      },

      arrayHojeChartSenhasGeradas24Horas: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      arrayOntemChartSenhasGeradas24Horas: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      arrayChartSenhasGeradas: [],
      chartSenhasGeradas24Horas: null,
      chartSenhasGeradas: null,
      menu: false,
      dadosDashboard: true,
      qtdMedicos: '',
      qtdAtendente: '',
      qtdRecepcionista: '',
      qtdTecnico: '',
      qtdServicos: '',
      qtdVisor: '',
      qtdApoio: '',
      qtdMedicosOnline: 0,
      qtdTecnicosOnline: 0,
      qtdRecepcionistasOnline: 0,
      qtdApoiosOnline: 0,
      qtdVisoresOnline: 0,
      qtdAtendentesOnline: 0,
      total: 0,
      dadosGrafico: [],
      loadingChartStatus: false,
      textButtonAtualizarChartStatus: 'Atualizar dados'
    }
  },

  mounted () {
    console.log('em mounted AdminUnidade..')
    this.user = this.$store.getters.usuario
    if (this.user.tipo != 5) {
      this.$router.push('/login')
      return
    }
    this.socket = io.connect(socketService.SOCKET_URL, {
      query: {
        token: getToken()
      }
    })
    this.chamarSocket()
    this.registrarTempoSocket()
    this.retornarDashboard()
    this.retornarQuantFuncionariosOnline()
    this.chartSenhasGeradas24Horas = new ApexCharts(
      document.querySelector('#chartSenhasGeradas24Horas'),
      this.optionschartSenhasGeradas24Horas
    )
    this.chartSenhasGeradas24Horas.render()
  },

  created () {
    console.log('created...')
    this.retornarQuantSenhas24Horas()
    // this.retornarQuantSenhasGeradas();
    this.retornarQuantAtendimentoStatus()
  },
  methods: {
    mapearDadosGrafico24Horas (dados) {
      var today = new Date()
      var diaMes = today.getDate() // retorna o dia do mes
      console.log('dia', diaMes)
      if (dados.length) {
        if (dados[0].dia == diaMes) {
          dados.forEach(element => {
            if (element.horas >= 6 && element.horas <= 17) {
              this.arrayHojeChartSenhasGeradas24Horas[element.horas - 6] =
                  element.quantAtendimentos
            }
          })
          this.chartSenhasGeradas24Horas.updateSeries([{
            name: 'Ontem',
            data: this.arrayOntemChartSenhasGeradas24Horas
          },
          {
            name: 'Hoje',
            data: this.arrayHojeChartSenhasGeradas24Horas
          }
          ])
        } else {
          // dia diferente quer dizer que tem ontem
          dados.forEach(
            function (element, i) {
              if (element.horas >= 6 && element.horas <= 17) {
                if (element.dia == dados[0].dia) {
                  this.arrayOntemChartSenhasGeradas24Horas[element.horas - 6] =
                      element.quantAtendimentos
                } else {
                  this.arrayHojeChartSenhasGeradas24Horas[element.horas - 6] =
                      element.quantAtendimentos
                }
              }
            }.bind(this)
          )
          this.chartSenhasGeradas24Horas.updateSeries([{
            name: 'Ontem',
            data: this.arrayOntemChartSenhasGeradas24Horas
          },
          {
            name: 'Hoje',
            data: this.arrayHojeChartSenhasGeradas24Horas
          }
          ])
        }
      } else {
        // array vazio
        this.chartSenhasGeradas24Horas.updateSeries([{
          name: 'Ontem',
          data: this.arrayOntemChartSenhasGeradas24Horas
        },
        {
          name: 'Hoje',
          data: this.arrayHojeChartSenhasGeradas24Horas
        }
        ])
      }
    },

    retornarQuantSenhas24Horas () {
      administradorUnidadeService.administradorUnidade
        .retornarQuantSenhas24Horas()
        .then(rsp => {
          console.log('rsp retornarQuantSenhas24Horas:', rsp.data)
          this.dadosGrafico = rsp.data
          var dados = this.dadosGrafico
          this.mapearDadosGrafico24Horas(dados)
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    mapearGraficoStatusAtendimento (atendimentos) {
      var series = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      atendimentos.forEach(element => {
        switch (element.status) {
          case 'pendente':
            series[0] = element.quantAtendimento
            break
          case 'chamando':
            series[1] = element.quantAtendimento
            break
          case 'emAtendimentoAtendente':
            series[2] = element.quantAtendimento
            break
          case 'atendimentoTransferido':
            series[3] = element.quantAtendimento
            break
          case 'atendimentoEmEspera':
            series[4] = element.quantAtendimento
            break
          case 'cancelado':
            series[5] = element.quantAtendimento
            break
          case 'naoAtendido':
            series[6] = element.quantAtendimento
            break
          case 'atendido':
            series[7] = element.quantAtendimento
            break
          case 'chamandoPaciente':
            series[8] = element.quantAtendimento
            break
          case 'emAtendimento':
            series[9] = element.quantAtendimento
            break
          case 'consultado':
            series[10] = element.quantAtendimento
            break
          default:
            break
        }
      })

      this.seriesAtendimentoStatus = series
      this.loadingChartStatus = false
      this.textButtonAtualizarChartStatus = 'Dados Atualizados com Sucesso!'
      setTimeout(() => {
        this.textButtonAtualizarChartStatus = 'Atualizar dados'
      }, 3000)
    },

    retornarQuantAtendimentoStatus () {
      this.loadingChartStatus = true
      administradorUnidadeService.administradorUnidade
        .retornarQuantAtendimentoStatus()
        .then(rsp => {
          console.log('rsp retornarQuantAtendimentoStatus:', rsp.data)
          var atendimentos = rsp.data
          this.mapearGraficoStatusAtendimento(atendimentos)
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    retornarDashboard () {
      administradorUnidadeService.administradorUnidade
        .retornarDashboard()
        .then(rsp => {
          console.log('rsp oi return dash:')
          console.log(rsp.data)
          this.qtdMedicos = rsp.data[0].medico
          this.qtdAtendente = rsp.data[0].atendente
          this.qtdRecepcionista = rsp.data[0].recepcionista
          this.qtdVisor = rsp.data[0].visor
          this.qtdApoio = rsp.data[0].apoio
          this.qtdServicos = rsp.data[0].servico
          this.qtdTecnico = rsp.data[0].tecnico
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    retornarQuantFuncionariosOnline () {
      administradorUnidadeService.administradorUnidade
        .retornarQuantFuncionariosOnline()
        .then(rsp => {
          console.log('rsp retornarQuantFuncionariosOnline:', rsp.data)
          this.total = rsp.data.total
          if (rsp.data.medico) {
            this.qtdMedicosOnline = rsp.data.medico
          }
          if (rsp.data.tecnico) {
            this.qtdTecnicosOnline = rsp.data.tecnico
          }
          if (rsp.data.apoio) {
            this.qtdApoiosOnline = rsp.data.apoio
          }
          if (rsp.data.visor) {
            this.qtdVisoresOnline = rsp.data.visor
          }
          if (rsp.data.recepcionista) {
            this.qtdRecepcionistasOnline = rsp.data.recepcionista
          }
          if (rsp.data.atendente) {
            this.qtdAtendentesOnline = rsp.data.atendente
          }
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },
    chamarSocket () {
      this.socket.on(
        'novaFichaGerada',
        function (mensagem) {
          var hoje = new Date()
          var diaMes = hoje.getDate()
          var hora = hoje.getHours()
          console.log('skt novaFichaGerada', mensagem)
          console.log('hora', hora)
          if (mensagem.idUnidade == this.user.idUnidade) {
            if (hora >= 6 && hora <= 17) {
              this.arrayHojeChartSenhasGeradas24Horas[hora - 6] =
                  this.arrayHojeChartSenhasGeradas24Horas[hora - 6] + 1
              this.chartSenhasGeradas24Horas.updateSeries([{
                name: 'Ontem',
                data: this.arrayOntemChartSenhasGeradas24Horas
              },
              {
                name: 'Hoje',
                data: this.arrayHojeChartSenhasGeradas24Horas
              }
              ])
              this.registrarTempoSocket()
            }
          }
        }.bind(this)
      )
    },

    registrarTempoSocket () {
      var date = new Date()
      var finaltime = timeSince(date)
      clearInterval(this.intervalRegistroSocket)
      this.intervalRegistroSocket = setInterval(
        function () {
          this.textTempoAtualizado = timeSince(date)
        }.bind(this),
        30000
      )
      this.textTempoAtualizado = timeSince(date)

      function timeSince (date) {
        var seconds = Math.floor((new Date() - date) / 1000)
        var interval = Math.floor(seconds / 31536000)

        if (interval > 1) {
          return interval + ' anos'
        }
        interval = Math.floor(seconds / 2592000)
        if (interval > 1) {
          return interval + ' mêses'
        }
        interval = Math.floor(seconds / 86400)
        if (interval > 1) {
          return interval + ' dias'
        }
        interval = Math.floor(seconds / 3600)
        if (interval > 1) {
          return interval + ' horas'
        }
        interval = Math.floor(seconds / 60)
        if (interval >= 1) {
          return interval + ' minutos'
        }
        return Math.floor(seconds) + ' segundos'
      }
    }
  }
}
</script>

  <style scoped>
  .md-card {
    width: 320px;
    margin: 4px;
    display: inline-block;
    vertical-align: top;
  }

  .feedback {
    background-color: #31b0d5;
    color: white;
    padding: 10px 20px;
    border-radius: 4px;
    border-color: #46b8da;
  }

  #mybutton {
    position: fixed;
    bottom: -4px;
    right: 10px;
  }

  .v-sheet--offset {
    top: -0px;
    position: relative;
  }

  @import url(https://fonts.googleapis.com/css?family=Roboto);

  body {
    font-family: Roboto, sans-serif;
  }

  #chartSenhasGeradas {
    margin: 300px auto;
  }

  #mybutton {
    position: fixed;
    bottom: 20px;
    right: 10px;
  }
  </style>
